/**
 * 车辆基本信息
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 获取车辆基本信息
// 接口地址  /api/v1/auctions/{auction_id}/basics
Mock.mock(/\/auctions\/\d+\/basics/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'auction_id': '1',
    'basics': {
      'basic': {
        'modelId': '',
        'brandName': '呜呜呜呜',
        'carModel': '6',
        'vin': 'WDBGP57B6PB127810',
        'displacement': '3.0L',
        'displacementLevelModel': '3',
        'inletModel': '5',
        'oilSystemModel': '3',
        'transmissionModel': '3',
        'driveModel': '3',
        'mile': '22',
        'colorModel': '3',
        'carColorChangeModel': '有变更',
        'productDate': '2017-03-22',
        'license_issued_on': '2017-03-22',
        'addressValue1': ['110000', '110100'],
        'addressValue2': ['140000', '140100'],
        'plateNumber': '9969696',
        'natureModel': '1',
        'nature2Model': '3',
        'carRrefitModel': '是',
        'guidePrice': '10000'
      },
      'config': {
        safeAirBag: '无',
        AntiLock: '无',
        brakeAssist: '无',
        stabilityControl: '无',
        rearviewMirror: '无',
        navigation: '无',
        cdDvd: '加装',
        airConditioner: '无',
        lock: '加装',
        remoteKey: '无',
        oneButtonStart: '加装',
        powerWindow: '无',
        distanceControl: '加装',
        distanceVideo: '无',
        spareTire: '加装',
        cruiseControl: '无',
        electricSunroof: '加装',
        leatherSeats: '无',
        electricRegulation: '加装'
      },
      'procedure': {
        'purchaseTax': '2',
        'drivingLicense': '有',
        'registration': '无',
        'annualDue': '2017-03-04',
        'strongInsurance': '2017-03-04',
        'commercialInsurance': '2017-03-04',
        'carInvoice': '有',
        'carWarranty': '过保',
        'key': '112',
        'maintenanceManual': '有',
        'instructions': '无',
        'unHandleIllegal': '有',
        'transferTimes': '112',
        'transferTickets': '有',
        'newPlace': '2',
        'proceduresSpend': '2'
      },
      'remark': '哇哇哇哇哇123131'
    }
  }
})
